import Vue from 'vue'
import Router from 'vue-router'
import Loader from './views/Loader.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Loader,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: () => import('./views/ResetPassword.vue')
    },
    {
      path: '/change-password/:uidb64/:token',
      name: 'ChangePassword',
      component: () => import('./views/ChangePassword.vue')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('./views/Dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('./views/Settings.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/parameters',
      name: 'parameters',
      component: () => import('./views/Supervisor.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '/parameters/:skill',
          name: 'skillView',
          component: () => import('./components/supervisor/skill-view.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/parameters/:skill/:agentID',
          name: 'agentView',
          component: () => import('./components/supervisor/user-view.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/supervisor-statistics',
      name: 'SupervisorStatistics',
      component: () => import('./views/SupervisorStatistics.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/notes',
      name: 'Notes',
      component: () => import('./views/Notes.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/statistics',
      name: 'Statistics',
      component: () => import('./views/Statistics.vue'),
      meta: { requiresAuth: true }
    }
  ]
})
